import { environment } from '../../environments/environment';

const baseUrl: string = environment.HbaseUrl + 'api/';
const assetsUrl: string = environment.assetsUrl;

const homeUrl: string = 'assets/api/groupBreaks';
const aboutUrl: string = 'assets/api/about';
const productsUrl: string = 'assets/api/products';
const successUrl: string = 'assets/api/success';
const cooperationUrl: string = 'assets/api/cooperation';

export const config: any = {
	// ** web 2.0
	about: assetsUrl + aboutUrl,
	home: assetsUrl + homeUrl, // 取得首頁好卡資訊
	products: assetsUrl + productsUrl,
	success: assetsUrl + successUrl,
	cooperation: assetsUrl + cooperationUrl,
};
